import { usePermissions } from "./use-permissions";

/**
 * Permission-based feature gates
 */

/**
 * Returns true when the current user can manage milestone analyses
 * (retry, regenerate, history, approve/publish).
 * This is restricted to admins only.
 */
export function useMilestoneAnalysisAdminEnabled(): boolean {
  const { isAdmin } = usePermissions();
  return isAdmin ?? false;
}
